import { render, staticRenderFns } from "./DirectUse.vue?vue&type=template&id=48350a0a&"
import script from "./DirectUse.vue?vue&type=script&lang=js&"
export * from "./DirectUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports